const baseURL = "https://drive.google.com/uc?export=view&id=";
const commonTitle = "Grupa Duminicala";

const youth = [
  {
    url: baseURL + "1V4Ntf4B0VJoEg5h5T7M4Alwp0Fa9_379",
    title: commonTitle,
    description: "",
  },
  {
    url: baseURL + "1j8uG7kHoF1ABvJcirD8Sgj39YF41l02g",
    title: commonTitle,
    description: "",
  },
  {
    url: baseURL + "163PVe6HVJyTUcZHILWZ9nVHc2f2JsVOT",
    title: commonTitle,
    description: "",
  },
  {
    url: baseURL + "1S2khcbzp0nBBOlbbD6vzcAA0DNPEFNka",
    title: commonTitle,
    description: "",
  },
  {
    url: baseURL + "1W-gqB5B_yNC5jLmsmuf1dKIC85xeu77P",
    title: commonTitle,
    description: "",
  },
  {
    url: baseURL + "1X63FnTzrLskURcgL3LUv4rg2J2I2T0TF",
    title: commonTitle,
    description: "",
  },
  {
    url: baseURL + "1uc4G4z6nlqr2H8fcgpfyUuNNlKBX6Tj1",
    title: commonTitle,
    description: "",
  },
  {
    url: baseURL + "1NK4K_eRPpmmkA8fulH3ohI04DxsA5KuR",
    title: commonTitle,
    description: "",
  },
  {
    url: baseURL + "1bqjXF72KjrUOqRRlcFFBgX-RtxhyiTmd",
    title: commonTitle,
    description: "",
  },
  {
    url: baseURL + "1ZafEMrtVMQ7vMQt-wCWkw2Nw-lNFEJaE",
    title: commonTitle,
    description: "",
  },
  {
    url: baseURL + "1g0RiqlS1dHd1kJOf9jqi_OUHlUHJa-Fa",
    title: commonTitle,
    description: "",
  },
  {
    url: baseURL + "1gsH6PWLFJhU2Da0w1TnsoYGPn4n5hi8l",
    title: commonTitle,
    description: "",
  },
  {
    url: baseURL + "1ZuiLFfHfZybKfaSSg8fnKASbqimc35K9",
    title: commonTitle,
    description: "",
  },
  {
    url: baseURL + "10ZVBw9CVliAeyHoMk6YPbMua3aYgAhFR",
    title: commonTitle,
    description: "",
  },
  {
    url: baseURL + "1WZbBFgcTJwgg4cGu-mSV0O9pqdjFDgME",
    title: commonTitle,
    description: "",
  },
  {
    url: baseURL + "1CMF4d6347N2kB_02qGVWq_QNik0fPD5B",
    title: commonTitle,
    description: "",
  },
  {
    url: baseURL + "1a0ra_p8UHZabT7x6G-MGyalt9ZYeL3B5",
    title: commonTitle,
    description: "",
  },
  {
    url: baseURL + "1axcahaqUV5c14b386B-ECfxz883zD88b",
    title: commonTitle,
    description: "",
  },
  {
    url: baseURL + "1gMcXHbhsCb_y0pOC5n3Aq_z3BXw6cWOs",
    title: commonTitle,
    description: "",
  },
  {
    url: baseURL + "1a0Orb6dxvnDQmpECECoBjwHFdVrfnDtT",
    title: commonTitle,
    description: "",
  },
  {
    url: baseURL + "16coYtJVPcnd0DpknCzQVRnkh8KKYte2T",
    title: commonTitle,
    description: "",
  },
  {
    url: baseURL + "1Mz3kDdyeXMo_ViD7RWBcyHRql0EyBQBv",
    title: commonTitle,
    description: "",
  },
  {
    url: baseURL + "11O9EcGASOtt3SRr9x1uJNypykxFpMXzn",
    title: commonTitle,
    description: "",
  },
  {
    url: baseURL + "1ST6Z8Mg8kOX0dzYCZBJ3aviYif0PxO2l",
    title: commonTitle,
    description: "",
  },
  {
    url: baseURL + "1uma6qq4u-DKvnWfjU-CMyDO_JbhkMSjP",
    title: commonTitle,
    description: "",
  },
  {
    url: baseURL + "1_Nc83Zm4992p75bCO39kXYs8183bqQw2",
    title: commonTitle,
    description: "",
  },
];

export default youth;
